// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rotate[data-v-e3e0b8f4]{transition:all .1s ease-in}.open[data-v-e3e0b8f4]{transform:rotate(90deg)}.closed[data-v-e3e0b8f4]{transform:rotate(-90deg)}.quick-navigation[data-v-e3e0b8f4] .dropdown-menu{width:250px!important;padding:10px}.icon[data-v-e3e0b8f4]{max-width:75px;max-height:75px}.icon-text[data-v-e3e0b8f4]{font-weight:600;margin-top:1em}a[data-v-e3e0b8f4]{text-decoration:none;color:#2f353a}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
